// Üretim Tanımları (iş istasyonları ve operasyonlar) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.definitions';

export const productionDefinitionsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Üretim tanımları nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Operasyonlu üretimin temelini burada kurarsınız: işin yapıldığı iş istasyonları ve tekrar tekrar kullanılan operasyonlar. Bunlar reçetenin rotasında (operasyon adımlarında) kullanılır ve üretim süresini ve maliyetini belirler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'İş İstasyonları / Operasyonlar'),
    filters: t(`${G}.regions.filters`, 'Ara, durum, şube'),
    toolbar: t(`${G}.regions.toolbar`, 'Ekle'),
    table: t(`${G}.regions.table`, 'Liste'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Önce iş istasyonlarını tanımlayın'),
      text: t(`${G}.s1.text`, '"İş İstasyonları" görünümünde "Ekle" ile işin yapıldığı makineyi, tezgâhı ya da bölümü tanımlayın (ör. Fırın, Kesim). İstasyonun saatlik makine ve işçilik maliyeti, o istasyonda geçen sürenin maliyetini belirler.'),
      tips: [
        t(`${G}.s1.tip1`, 'Adım maliyeti = süre (dk) / 60 × (makine ₺/saat + işçilik ₺/saat). Planlanan süre = hazırlık süresi + birim süre × miktar.'),
        t(`${G}.s1.tip2`, 'Atölye ekranındaki "İstasyon" listesinde aktif istasyonlar çıkar.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s2.title`, '2. Sonra operasyonları tanımlayın'),
      text: t(`${G}.s2.text`, '"Operasyonlar" görünümünde sık yapılan işleri (ör. Hamur yoğurma, Paketleme) varsayılan istasyonu, hazırlık süresi ve birim süresiyle kaydedin. Rotaya adım eklerken operasyonu seçince bu değerler adıma kendiliğinden gelir; adımda değiştirebilirsiniz.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Kaydı bulun'),
      text: t(`${G}.s3.text`, '"Ara" ile kod veya ada göre arayın, "Durum" ile Aktif / Pasif kayıtları süzün. İstasyonlarda birden çok şube varsa "Şube" ile daraltabilirsiniz.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Listeyi okuyun ve düzenleyin'),
      text: t(`${G}.s4.text`, 'İstasyon listesinde Kod, Ad, Şube (boşsa "Şirket geneli"), Makine ₺/saat, İşçilik ₺/saat, Kapasite ve Durum; operasyon listesinde Kod, Ad, Varsayılan istasyon, Hazırlık (dk) ve Birim süre (dk) görünür. İşlemler sütunundan Düzenle, Pasife al / Aktif et ve Sil yapılır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Bir rotada (istasyon için ayrıca bir operasyonun varsayılan istasyonu olarak) kullanılan kayıt silinemez; "n yerde kullanılıyor; pasife alın" uyarısı çıkar. Bu durumda kaydı pasife alın.'),
        t(`${G}.s4.tip2`, 'Şube yöneticisi yalnız kendi şubesinin istasyonlarını değiştirebilir; şirket geneli istasyonlar ona yalnız görünür.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Sayfalar arasında gezinin'),
      text: t(`${G}.s5.text`, 'Kayıt çoksa alttaki sayfalamayı kullanın. Başlıktaki (i) bu rehberi yeniden açar; ekleme pencerelerinin kendi (i) rehberleri vardır.'),
    },
  ],
});
